module.exports = __webpack_public_path__ + "assets/crane.svg?9cca507105455f02ea95e87741b438ac";